import { Box, Typography } from "@mui/material"

import { Grid, WYSIWYG, type FC } from ".."

type ColumnProps = {
  title?: string
  description: string
}

export type SplitBodyProps = {
  leftContent: ColumnProps
  rightContent: ColumnProps
}

const SplitBody: FC<SplitBodyProps> = ({ leftContent, rightContent }) => {
  return (
    <Grid component="article" sx={{ rowGap: 10 }}>
      <ColumnContent position="left" content={leftContent} />
      <ColumnContent position="right" content={rightContent} />
    </Grid>
  )
}

export default SplitBody

/** A sub-component for the column content */
type ContentProps = {
  position: "left" | "right"
  content: ColumnProps
}
const ColumnContent: FC<ContentProps> = ({ position, content }) => {
  return (
    <Box
      gridColumn={
        position === "left"
          ? { xs: "1 / -1", md: "1 / span 4", lg: "2 / span 5" }
          : { xs: "1 / -1", md: "6 / span 3", lg: "8 / span 4" }
      }
      borderTop={(theme) =>
        position === "right"
          ? { xs: `1px solid ${theme.palette["neutral.200"].main}`, md: "0" }
          : "0"
      }
      pt={{
        xs: position === "right" ? 10 : 0,
        md: 0,
      }}
    >
      {content.title && (
        <Typography variant="heading.lg" component="h3" mb={{ xs: 5, md: 10 }}>
          {content.title}
        </Typography>
      )}
      <WYSIWYG
        content={content.description}
        sx={{
          "h1, h2, h3, h4": {
            mb: 10,
          },
        }}
      />
    </Box>
  )
}
